import { render } from "./FullscreenAdPropsCmp.vue?vue&type=template&id=08ea2123"
import script from "./FullscreenAdPropsCmp.vue?vue&type=script&lang=js"
export * from "./FullscreenAdPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__